export default __webpack_public_path__ + "static/media/realyFooterLogo.bee3cc0a.svg";